import { sendVerificationCode } from 'Api/api';
import { useMutation } from 'react-query';
import { IOtpVerificationRequestBody } from 'Types/Interface/IUser';

export const useSendVerification = () => {
	return useMutation((data: IOtpVerificationRequestBody) => sendVerificationCode(data));
};
